
import Upload from './Upload';
import UploadList from './UploadList';

Upload.List = UploadList;

export default Upload;
